<main class="page-body">
  <mat-card appearance="outlined" class="content-center not-found-error">
    <h2>We Couldn’t Find That Page</h2>
    <img src="/assets/robot-icon.svg" width="208px" />
    <button
      mat-flat-button
      color="accent"
      class="create-button"
      [routerLink]="'/'"
    >
      Back to Home
    </button>
  </mat-card>
</main>
